<template>
  <div class="animated fadeIn">
    <div class="row d-flex justify-content-end">
      <div class="col-sm-6">

      </div>
      <div class="col-sm-6 text-right dk-button-sync-container d-flex justify-content-end">
        <b-form-select name="c_branch" v-model="c_branch" @change="fetchData" :options="branchOptions"></b-form-select>
        <a @click="syncKeysoftAll()" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Sync All</a>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="title font-300 font-24 mb-15">
          {{this.$route.name}}
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <div class="width-auto-picker d-flex justify-content-end">
            <b-form-select @change="fetchData" name="formType" v-model="currentCs" :options="options" class="mr-3" />
          <flat-pickr @on-change="changeCurrentDate" :config="exportConfig" class="font-13 text-center" v-model="searchDate" name="export_date_start"></flat-pickr>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="box-mini mb-20">
          <div class="p-15">
            <div class="font-500">EDC BCA</div>
            <table class="table table-striped text-center mb-0">
              <thead>
                <tr>
                  <td><strong>Type</strong></td>
                  <td><strong>Total</strong></td>
                  <td><strong>Revenue</strong></td>
                  <td><strong>Revenue VAT</strong></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(type, index) in items">
                  <tr :key="index">
                    <td class="text-left">{{ formatTitle(type.key) }}</td>
                    <td>{{type.total}}</td>
                    <td>{{ parseRp(type.revenue) }}</td>
                    <td>{{ parseRp(type.revenue_vat) }}</td>
                    <td><button class="btn-primary" @click="syncKeysoft(type)" :disabled="checkButtonSync(type)">Sync</button></td>
                  </tr>
                </template>
                <tr>
                  <td class="text-right font-500" colspan="3">Total</td>
                  <td class="font-500">{{ parseRp(totalKeysoft) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Syncing Data ...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'gallery',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      options: [],
      currentCs: '',
      btnSyncStatus : [],
      searchDate: moment(new Date()).format('YYYY-MM-DD'),
      exportConfig: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d F Y",
        defaultDate: moment(new Date()).format('YYYY-MM-DD'),
        maxDate: "today"
      },
      totalKeysoft: 0,
      loadingActive: false,
      c_branch: '0',
      branchOptions: [
        { value: '0', text: 'Please select branch' },
        { value: '1', text: 'Paradigm Sequis Tower' },
        // { value: '2', text: 'Paradigm Home Office' },
        { value: '3', text: 'Paradigm Darmawangsa' }
      ]
    }
  },
  methods: {
    openPage (event) {
      this.$router.push(event)
    },
    formatTitle (value) {
        return value.replace(/(?:_| |\b)(\w)/g, $1 => $1.toUpperCase().replace('_',' '))
    },
    changeCurrentDate (selectedDates, dateStr, instance) {
      this.searchDate = dateStr
      this.fetchData()
    },
    parseRp (value) {
        return 'Rp. ' + parseInt(value).toLocaleString('id-ID', { maximumFractionDigits:0 })
    },
    checkButtonSync(row) {
      let data = this.btnSyncStatus.data.data
      let find = data.find(data => data.keysoft_transaction_type_id == row.keysoft_transaction_type_id)

      if (row.key == "alpha_membership_breakdown") {
        return true
      }

      if (row.key == "alpha_session_breakdown") {
        return true
      }

      if(find){
        return true
      }else{
        return false
      }
    },
    // sync all data
    async syncKeysoftAll() {
      if (!this.currentCs) {
            this.$toast.success('please select customer service', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
            })
            return
        }

        if (this.c_branch == '0') {
            this.$toast.success('please select Branch', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
            })
            return
        }

      let isConfirm = await this.$swal({
            title: 'Are you sure?',
            text: 'You can\'t revert your action',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes Sync it!',
            cancelButtonText: 'No, Keep it!',
            showCloseButton: true,
            showLoaderOnConfirm: false
        })
        if (isConfirm.value) {
            this.loadingActive = true
            let data = this.btnSyncStatus.data.data
            for (let i = 0; i < this.items.length; i++) {
              let find = data.find(data => data.keysoft_transaction_type_id == this.items[i].keysoft_transaction_type_id)
              console.log(find);
              if (this.items[i].revenue != 0) {
               if (!find) {
                 await axios.post('transaction/v1/keysoft/manual_'+this.items[i].key+'_revenue?date='+this.searchDate+'&branch_id='+this.c_branch, {
                      customer_service_id: this.currentCs,
                      revenue: this.items[i].revenue,
                      amount: this.items[i].total,
                      date: this.searchDate
                  })
                }
              }
            }
            this.loadingActive = false
            this.fetchData()
            this.$swal('Success', 'You successfully sync this file', 'success')
        } else {
            this.$swal('Cancelled', 'Your transaction cancelled', 'info')
        }
    },
    async refreshButton(){
      this.btnSyncStatus = await axios.get('transaction/v1/keysoft_revenue/check_button_sync?date=' + this.searchDate)
    },
    async fetchData() {
        let report = await axios.get('crm/v1/report/paradigm_revenue?date=' + this.searchDate+'&branch_id='+this.c_branch)
        this.btnSyncStatus = await axios.get('transaction/v1/keysoft_revenue/check_button_sync?date=' + this.searchDate+'&branch_id='+this.c_branch)
        let keys = Object.keys(report.data).map(val => val.replace('_revenue', '').replace('_total', '').replace('_vat', '').replace('_keysoft_transaction_type_id', ''))
        let uniqueKeys = [...new Set(keys)]
        this.items=[]
        this.totalKeysoft=0
        setTimeout(() => {

        }, 5000);
        uniqueKeys.forEach(row => {
            this.items.push({
                key: row,
                total: report.data[`${row}_total`],
                revenue: report.data[`${row}_revenue`],
                revenue_vat: report.data[`${row}_vat`],
                keysoft_transaction_type_id: report.data[`${row}_keysoft_transaction_type_id`],
            })
            this.totalKeysoft += parseInt(report.data[`${row}_revenue`])
        })
        let cs = await axios.get('crm/v1/customer_service')
        this.options = [{ value: '', text: 'Please select' }]
        cs.data.data.rows.forEach(row => {
            this.options.push({ value: row.id, text: row.id +' '+ row.name })
        })
    },
    async syncKeysoft (row) {
        if (!this.currentCs) {
            this.$toast.success('please select customer service', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
            })
            return
        }
        if (this.c_branch == '0') {
            this.$toast.success('please select Branch', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
            })
            return
        }

        let isConfirm = await this.$swal({
            title: 'Are you sure?',
            text: 'You can\'t revert your action',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes Sync it!',
            cancelButtonText: 'No, Keep it!',
            showCloseButton: true,
            showLoaderOnConfirm: false
        })
        if (isConfirm.value) {
            this.loadingActive = true
            await axios.post('transaction/v1/keysoft/manual_'+row.key+'_revenue?date='+this.searchDate+'&branch_id='+this.c_branch, {
                customer_service_id: this.currentCs,
                revenue: row.revenue,
                amount: row.total,
                date: this.searchDate
            })
            this.loadingActive = false
            this.fetchData()
            this.$swal('Success', 'You successfully sync this file', 'success')
        } else {
            this.$swal('Cancelled', 'Your transaction cancelled', 'info')
        }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
